import { styled, Typography } from '@mui/material';

export const SectionHeading = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: '18px',
  color: theme.palette.modal.title,
}));

export const SectionSubheading = styled(SectionHeading)({
  fontSize: '16px',
});
